import { faUser } from '@fortawesome/pro-solid-svg-icons'

import { PortalSectionEnum } from 'Constants/portalSection'

export const PRESENTATION_ITEM = {
  icon: faUser,
  id: 12,
  key: PortalSectionEnum.Dashboard,
  name: 'Dashboard',
  path: '/dashboard',
}
